import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import React from 'react';
import styled from 'styled-components';
import { convertDatasets } from 'src/utils/datasets';
function SectionFour({ dataSet, ref, className }: any) {
  const allData = {
    item1: convertDatasets(dataSet, 'desc-1', true),
    item2: convertDatasets(dataSet, 'img-left', true),
    item3: convertDatasets(dataSet, 'desc-2', true),
    item4: convertDatasets(dataSet, 'img-right', true),
    item5: convertDatasets(dataSet, 'reserve-link', true)
  };
  return (
    <SectionWrapper className={className}>
      <div className='container' ref={ref}>
        <div className='desc-text' dangerouslySetInnerHTML={{ __html: find(dataSet, { key: 'title-text' })?.value }}></div>
        <div className='image'>
          {!isEmpty(allData.item2) && (
            <div className='image-left'>
              <img src={allData?.item2} title={'image-icon'} />
            </div>
          )}
          {!isEmpty(allData.item4) && (
            <div className='image-right'>
              <img src={allData?.item4} title={'image-icon'} />
            </div>
          )}
        </div>
        <div className='content'>
          <span>{allData.item1}</span>
          <span>{allData.item3}</span>
        </div>
        {!isEmpty(allData.item5) && (
          <div className='btn'>
            <a href={allData.item5} target='_blank'>
              ลงทะเบียน
            </a>
          </div>
        )}
        {/* <div className='section-2'>
          <div className='text-desc-1'>
            เงื่อนไขการจำหน่ายบัตร <br></br>• เริ่มจำหน่ายบัตรทางไทยทิคเก็ตเมเจอร์ ตั้งแต่วันที่ 10 มิถุนายน 2666 เป็นต้นไป (ทุกช่องทางการจำหน่าย) <br></br>• จำกัดการซื้อบัตรไม่เกิน 4 ใบ ต่อ 1
            การทำรายการซื้อ 1 ครั้ง(ทุกช่องทางการจำหน่าย) <br></br>• บัตรทุกใบ เป็นบัตรนั่ง <br></br>• บัตรจำหน่ายทาง Thaiticketmajor ทุกสาขา และ www.thaiticketmajor.com หรือ TTM.Callcenter 0 22623456{' '}
            <br></br>• ตรวจสอบรายละเอียดจุดจำหน่ายบัตร ได้ที่{' '}
            <u>
              สร้างความทรงจำครั้งสำคัญครั้งใหม่ไปด้วยกัน เฉลียง Rare Item คอนเสิร์ต <br></br>ทุกบทเพลง ทุกความทรงจำ กำลังจะกลับมาสร้างรอยยิ้มอีกครั้ง<br></br> สามารถซื้อบัตรได้ตั้งแต่วันที่ 10
              มิถุนายน 2566 เป็นต้นไป
              <br></br>เปิดจำหน่ายบัตรที่ : ThaiTicketMajor ทุกสาขา และ www.thaiticketmajor.com <br></br>/ Callcenter TTM. 0 2262 3456
            </u>
          </div>
          <div className='text-desc-2'>
            • บัตรจำหน่ายทางไทยทิคเก็ตเมเจอร์ มีค่าธรรมเนียมการออกบัตรใบละ 30 บาท และคิดค่าธรรมเนียมการจัดส่งบัตร 60 บาท/รายการสั่งซื้อ (ในกรณีเลือกจัดส่งบัตร) <br></br>• การชำระเงินผ่านบัตรเครดิต,
            บัตรเดบิต, True Wallet , Shopee Pay มีค่าธรรมเนียม convenience fee 3 % สำหรับการชำระเงินผ่าน BBL iBanking , K Pay+ มีค่าธรรมเนียม convenience fee 0.5 % <br></br>•
            ทางผู้จัดงานไม่อนุญาตให้นำบัตรไปใช้ประโยชน์ทางการค้า,การทำโปรโมชั่นกับสินค้า เช่น การลด, แลก, แจก, แถม เว้นแต่จะได้รับความยินยอมจากทางผู้จัดงาน <br></br>•
            การนำบัตรไปขายต่อหรือแจกเพื่อการโฆษณาหรือประชาสัมพันธ์โดยไม่ได้รับอนุญาตจากบริษัทฯ ถือว่ามีความผิดทางกฏหมาย <br></br>• การซื้อบัตรจากช่องทางอื่น ที่ไม่ใช่ไทยทิคเก็ตเมเจอร์ ทางบริษัทฯ
            จะไม่รับผิดชอบในกรณีใด ๆ ทั้งสิ้น <br></br>• โปรดระวังมิจฉาชีพที่แฝงมาในรูปแบบต่าง ๆ เช่น การรับจองบัตร การให้โค้ดจอง การซื้อ-ขายบัตรนอกระบบ การแอบอ้างเป็นพนักงานบริษัทฯ เป็นต้น <br></br>•
            ทางผู้จัดงานขอสงวนสิทธิ์ในการเปลี่ยนแปลงเงื่อนไข โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า
          </div>
          <div className='text-desc-3'>
            หมายเหตุ : <br></br>• ตรวจสอบจุดจำหน่ายได้ที่{' '}
            <u>
              สร้างความทรงจำครั้งสำคัญครั้งใหม่ไปด้วยกัน เฉลียง Rare Item คอนเสิร์ต ทุกบทเพลง ทุกความทรงจำ กำลังจะกลับมาสร้างรอยยิ้มอีกครั้ง สามารถซื้อบัตรได้ตั้งแต่วันที่ 10 มิถุนายน 2566 เป็นต้นไป
              เปิดจำหน่ายบัตรที่ : ThaiTicketMajor ทุกสาขา และ www.thaiticketmajor.com / Callcenter TTM. 0 2262 3456
            </u>
          </div>
          <div className='text-desc-4'>
            • ผู้ที่จองรอบวันเสาร์ รอบการแสดงเป็น 26 สิงหาคม 2566 เวลาแสดง 19:00 น. <br></br>• ผู้ที่จองรอบวันอาทิตย์ รอบการแสดงเป็น 27 สิงหาคม 2566 เวลาแสดง 13:00 น. <br></br>•
            สอบถามรายละเอียดเพิ่มเติม TTM. Callcenter 0 2262 3456
          </div>
          <div className='text-desc-5'>
            ข้อควรรู้ก่อนซื้อบัตร : <br></br>• ผู้ชมต้องได้รับวัคซีน Covid-19 ครบตามที่กำหนด อย่างน้อย 2 เข็ม ก่อนวันงาน <br></br>• กรณีไม่ได้รับวัคซีน หรือรับวัคซีนไม่ครบตามที่กำหนด ต้องแสดงรูปผลตรวจ
            ATK ภายใน 48 ชม.
            <br></br>• ผู้เข้าร่วมงานต้องสวมใส่หน้ากากอนามัยตลอดเวลา <br></br>• ก่อนเข้าชมคอนเสิร์ตผู้ชมทุกคนจะต้องมีบัตรเข้างาน และต้องลงทะเบียนเข้างานที่ระบบ Pre-Register ที่
            https://createintelligence.co.th/ หรือ สแกนคิวอาร์โด้ด หลังบัตรคอนเสิร์ต <br></br>• มาตรการอาจมีการเปลี่ยนแปลงตามสถานการณ์จากประกาศกรมควบคุมโรค
          </div>
        </div> */}
      </div>
    </SectionWrapper>
  );
}
const SectionWrapper = styled.div`
  position: relative;
  background-color: #d7929d;
  width: 100%;
  padding-bottom: 40px;

  .desc-text {
    color: #fff;
    text-align: center;
    font-size: 58px;
    font-weight: 900;
    padding: 40px 0 20px 0;
    cursor: context-menu;
    @media (max-width: 475px) {
      font-size: 34px;
    }
  }
  .image {
    display: flex;
    .image-left {
      width: 56%;
      img {
        display: flex;
        width: 100%;
      }
    }
    .image-right {
      width: 55.9%;
      img {
        display: flex;
        width: 100%;
      }
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 40px;
    span {
      text-align: center;
      font-size: 32px;
      font-weight: 300;
      @media (max-width: 768px) {
        font-size: 24px;
      }
      @media (max-width: 550px) {
        font-size: 18px;
      }
    }
  }
  .btn {
    text-align: center;
    margin: 50px 0 20px 0;
    @media (max-width: 550px) {
      margin: 30px 0 0px 0;
    }
    a {
      margin: auto;
      width: 100vw;
      background-color: #6b64a0;
      padding: 12px 24px;
      border-radius: 40px;
      color: #fff;
      font-weight: 500;
      font-size: 36px;
      @media (max-width: 1024px) {
        font-size: 28px;
      }
      @media (max-width: 690px) {
        font-size: 20px;
      }
      @media (max-width: 550px) {
        font-size: 16px;
        padding: 10px 20px;
      }
    }
  }

  /* .section-2 {
      position: relative;
      width: 90%;
      padding: 20px 25px;
      display: flex;
      flex-direction: column;
      align-self: flex-start;

      gap: 30px 0;
      .text-desc-1,
      .text-desc-2,
      .text-desc-3,
      .text-desc-4,
      .text-desc-5 {
        color: #fff;
        margin-bottom: 15px;
        font-size: 24px;
        font-weight: 350;
        letter-spacing: 0px;
        cursor: context-menu;

        @media (max-width: 992px) {
          font-size: 20px;
        }
        @media (max-width: 475px) {
          font-size: 18px;
        }
      }
    } */
`;
export default SectionFour;
